import { Component, OnInit,OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { LocationLoadingService } from './LocationLoading.service';

@Component({
  selector: 'app-LocationLoader',
  templateUrl: './LocationLoader.component.html'
})
export class LocationLoaderComponent  implements OnInit, OnDestroy {

  loading: boolean = false;
  loadingSubscription: Subscription;

  constructor(private loadingScreenService: LocationLoadingService) {
  }

  ngOnInit() {
    this.loadingSubscription = this.loadingScreenService.loadingStatus.subscribe((value) => {
      this.loading = value;
    });
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }

}
